module.exports = __webpack_public_path__ + "static/media/twitter-footer2.a2978eb3.svg";